import React from 'react';
import { createVersionedContext, createVersionedValueMap } from '@backstage/version-bridge';
import { RouteResolver } from './RouteResolver.esm.js';

const RoutingContext = createVersionedContext(
  "routing-context"
);
const RoutingProvider = ({
  routePaths,
  routeParents,
  routeObjects,
  routeBindings,
  basePath = "",
  children
}) => {
  const resolver = new RouteResolver(
    routePaths,
    routeParents,
    routeObjects,
    routeBindings,
    basePath
  );
  const versionedValue = createVersionedValueMap({ 1: resolver });
  return /* @__PURE__ */ React.createElement(RoutingContext.Provider, { value: versionedValue }, children);
};

export { RoutingProvider };
//# sourceMappingURL=RoutingProvider.esm.js.map
